import { Box, Typography } from "@mui/material";
import * as React from "react";
import {Row, Col, Divider } from "rsuite";
import SquareIcon from '@mui/icons-material/Square';
import UpSellOpportunityGraph from "./upSellOpportunityGraph";

export class UpSellOpportunity extends React.Component<any, any> {

    calculateAverageValue = (min: any, max: any) => (min + max) /2 ;

    render(): React.ReactNode {
        const { data, adjustPositionValue } = this.props;
       
        return <Row className="show-grid" style={{height: '100%', margin: '5px'}}>
        <Row className="show-grid" style={{height: '10%'}}>
            <Col className="alignCenter subHeadCU" style={{color: '#ffffff'}}>
                Customer Upsell Opportunity
            </Col>
        </Row>

        {data ? (
        <Row style={{height:'90%'}}>
            <Row style= {{paddingLeft:'10px', paddingBottom:'10px', height: '76%'}} className="show-grid">
                <Col xs={7} sm={7} md={7} className="alignCenter" style={{paddingTop:'25px'}}>
                    <span>
                        <span style={{color: 'white'}}>
                            Sales ($)
                        </span>
                        <Divider style={{color: 'white', marginTop:'6px', marginBottom: '10px'}} />
                        <UpSellOpportunityGraph minVal={Number((data?.opportunity?.sales?.min).toFixed(2))} maxVal={Number((data?.opportunity?.sales?.max).toFixed(2))}
                        currentState={Number((data?.opportunity?.sales?.currentState).toFixed(2))} recState={Number((data?.opportunity?.sales?.recState).toFixed(2))} 
                        avgVal={Number((data?.opportunity?.sales?.avg).toFixed(2))} adjustPositionValue={Number((data?.opportunity?.sales?.adjustedState).toFixed(2))}/>
                    </span>
                </Col>

                <Col md={1}>
                    <div className="separation" style={{height:'112px', paddingTop:'10px'}}/>
                </Col>
                
                <Col xs={7} sm={7} md={7} className="alignCenter" style={{paddingTop:'25px'}}>
                    <span>
                        <span style={{color: 'white'}}>
                            Price ($/case)
                        </span>
                        <Divider style={{color: 'white', marginTop:'6px', marginBottom: '10px'}} />
                        <UpSellOpportunityGraph minVal={Number((data?.opportunity?.price?.min).toFixed(2))} maxVal={Number((data?.opportunity?.price?.max).toFixed(2))}
                        currentState={Number((data?.opportunity?.price?.currentState).toFixed(2))} recState={Number((data?.opportunity?.price?.recState).toFixed(2))} 
                        avgVal={Number((data?.opportunity?.price?.avg).toFixed(2))} adjustPositionValue={Number((data?.opportunity?.price?.adjustedState).toFixed(2))}/>
                    </span> 
                </Col>

                <Col md={1} >
                    <div className="separation" style={{height:'112px', paddingTop:'10px'}}/>
                </Col>

                <Col xs={7} sm={7} md={7} className="alignCenter" style={{paddingTop:'25px'}}>
                    <span>
                        <span style={{color: 'white'}}>
                            Margin ($/case)
                        </span>
                        <Divider style={{color: 'white', marginTop:'6px', marginBottom: '10px'}} />
                        <UpSellOpportunityGraph minVal={Number((data?.opportunity?.margin?.min).toFixed(2))} maxVal={Number((data?.opportunity?.margin?.max).toFixed(2))}
                        currentState={Number((data?.opportunity?.margin?.currentState).toFixed(2))} recState={Number((data?.opportunity?.margin?.recState).toFixed(2))} 
                        avgVal={Number((data?.opportunity?.margin?.avg).toFixed(2))} adjustPositionValue={Number((data?.opportunity?.margin?.adjustedState).toFixed(2))}/>
                    </span>
                
                </Col>
            </Row>

            <Row className="show-grid"style={{height:'24%'}}> 
                <Col xs={5} sm={5} md={5} >
                    <Typography sx={{ height: '18px',width:'22px', backgroundColor: '#ffffff', float: 'left'}}>
                        <Box sx={{borderLeft: '3px dotted black', height: '18px',  position: 'absolute', left:'10%'}} />
                    </Typography>
                    <span style={{color: 'white', paddingLeft: '5px', fontSize: '0.67vw'}}>
                        Peer Customer Average
                    </span>
                </Col>

                <Col xs={5} sm={5} md={5} >
                    <Typography  sx={{ height: '18px',width:'20px', backgroundColor: '#ffffff', float: 'left'}} />
                    <span style={{color: 'white', paddingLeft: '5px', fontSize: '0.67vw'}}>
                        Peer Customer Range
                    </span>
                </Col>

                <Col xs={5} sm={5} md={5}>
                    <SquareIcon x="0" y="0"  sx={{color:'#d50a0a', width: '20px', height:'20px', float: 'left', paddingRight: '5px'}}/>
                    <span style={{color: 'white', fontSize: '0.67vw'}}>
                        Current State Position
                    </span>
                </Col>

                <Col xs={4} sm={4} md={4}>
                    <SquareIcon x="0" y="0" sx= {{transform: 'rotate(45deg)', color: '#FFC72C', width: '20px', height:'20px', float: 'left', paddingRight: '5px'}} /> 
                    <span style={{color: 'white', fontSize: '0.67vw'}}>
                        Recommended Position
                    </span>
                </Col>

                <Col xs={5} sm={5} md={5}>
                    <SquareIcon x="0" y="0" sx= {{transform: 'rotate(45deg)', color: '#0097a9', width: '20px', height:'20px', float: 'left', paddingRight: '5px'}} /> 
                    <span style={{color: 'white', fontSize: '0.67vw'}}>
                        Adjusted Position
                    </span>
                </Col>
            </Row>
        </Row>) : 
        (<Row>
            <Col>
                <span className="divTextCenter">Click on the left Table to get the Detailed view</span>
            </Col>  
        </Row>)
        }    
    </Row>
    }
}